import script from "./IncidentListComponentAux.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentListComponentAux.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentListComponentAux.vue?vue&type=style&index=0&id=1bafaa74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bafaa74"]])

export default __exports__